import {
  SECTION_TYPE,
  REGISTRATION_STATUS_TOTAL_DAYS
} from '../constants';

type ProgressDataType = {
  daysLeft?: number,
  endDate?: string,
  completed?: boolean,
  totalDays?: number,
  maxMilage?: number
}

const getProgressData = (data: any, sectionType: string) => {
  const { REGISTRATION_STATUS} = SECTION_TYPE;

  let progressData: ProgressDataType = {};

  switch (sectionType) {
    case REGISTRATION_STATUS:
      progressData = {
        daysLeft: data.daysLeft,
        endDate: data.completedOn,
        completed: data.completed,
        totalDays: REGISTRATION_STATUS_TOTAL_DAYS,
      };
      break;
    default:
      break;
  }

  return progressData;
}

export default getProgressData;